import { nationality_data } from "./all";

const useCorrectDemoLayoutForm = ({ identity }) => {
  const regionEng = identity?.region?.eng || "";
  const regionAmh = identity?.region?.amh || "";
  const zoneEng = identity?.zone?.eng || "";
  const zoneAmh = identity?.zone?.amh || "";
  const woredaEng = identity?.woreda?.eng || "";
  const woredaAmh = identity?.woreda?.amh || "";

  const layout = [
    {
      type: "profile",
    },
    {
      title: "demo-data",
      type: "edit",
      formFields: [
        {
          name: "nationality",
          label: "Nationality",
          type: "select",
          options: nationality_data?.map((item) => ({
            label: item.name,
            value: item.id,
          })),
          required: true,
        },
        {
          name: "nationality",
          label: "ዜግነት",
          type: "select",
          options: nationality_data?.map((item) => ({
            label: item.nameamh,
            value: item.id,
          })),
          required: true,
        },
        {
          name: "dateOfBirth",
          label: "Date Of Birth",
          type: "text",
          required: true,
        },
        {
          name: "dobAmh",
          label: "ትውልድ ቀን",
          type: "text",
          required: true,
        },
      ],
    },
    {
      type: "edit",
      title: "demo-data",
      formFields: [
        {
          grid: "col-span-2",
          name: "name",
          label: "Name",
          type: "name",
          required: true,
        },
        {
          name: "gender",
          label: "Gender",
          type: "select",
          options: [
            { label: "Male", value: "Male" },
            { label: "Female", value: "Female" },
          ],
          required: true,
        },
        {
          name: "gender",
          label: "ጾታ",
          type: "select",
          options: [
            { label: "ወንድ", value: "Male" },
            { label: "ሴት", value: "Female" },
          ],
          required: true,
        },
        {
          name: "phone",
          label: "Phone Number",
          type: "number",
          required: true,
        },
        {
          name: "email",
          label: "Email",
          type: "text",
          required: true,
        },
      ],
    },
    {
      title: "title-location",
      type: "edit",
      formFields: [
        {
          name: "region",
          label: "Region",
          type: "select",
          options: regionEng
            ? [{ label: regionEng, value: regionEng }]
            : [],
          required: true,
        },
        {
          name: "region",
          label: "ክልል",
          type: "select",
          options: regionEng
            ? [{ label: regionAmh || regionEng, value: regionEng }]
            : [],
          required: true,
        },
        {
          name: "zone",
          label: "Zone",
          type: "select",
          options: zoneEng ? [{ label: zoneEng, value: zoneEng }] : [],
          required: true,
        },
        {
          name: "zone",
          label: "ዞን",
          type: "select",
          options: zoneEng
            ? [{ label: zoneAmh || zoneEng, value: zoneEng }]
            : [],
          required: true,
        },
        {
          name: "woreda",
          label: "Woreda",
          type: "select",
          options: woredaEng
            ? [{ label: woredaEng, value: woredaEng }]
            : [],
          required: true,
        },
        {
          name: "woreda",
          label: "ወረዳ",
          type: "select",
          options: woredaEng
            ? [{ label: woredaAmh || woredaEng, value: woredaEng }]
            : [],
          required: true,
        },
      ],
    },
    {
      title: "previously-uploaded",
      type: "preview",
    },
  ];
  return { layout };
};

export default useCorrectDemoLayoutForm;
